import { render } from "./TestCaseValidationComparison.vue?vue&type=template&id=632638c4&scoped=true"
import script from "./TestCaseValidationComparison.vue?vue&type=script&lang=js"
export * from "./TestCaseValidationComparison.vue?vue&type=script&lang=js"

import "./TestCaseValidationComparison.vue?vue&type=style&index=0&id=632638c4&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632638c4"]])

export default __exports__
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTabPanel,QTab,QTabPanels});
